import { render, staticRenderFns } from "./LogoText.vue?vue&type=template&id=de8ecb2e&scoped=true&"
import script from "./LogoText.vue?vue&type=script&lang=js&"
export * from "./LogoText.vue?vue&type=script&lang=js&"
import style0 from "./LogoText.vue?vue&type=style&index=0&id=de8ecb2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8ecb2e",
  null
  
)

export default component.exports